class CustomFormStyles extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    this.initObserver();
  }

  initObserver() {
    this.observer = new MutationObserver(() => {
      const form = document.querySelector("#app-embed");

      if (form && form.shadowRoot) {
        this.observer.disconnect();
        const shadow = form.shadowRoot;

        const sheet = new CSSStyleSheet();
        sheet.insertRule(`
            #app-embed ._textBody_2aowh_10 {
                font-family: 'Instrument Sans';
                font-size: clamp(16px,1vw,20px);
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                text-align: left;
                width:87%;
            }
        `);

        sheet.insertRule(`
            #app-embed ._formFieldset_1nihh_63 {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
            }
        `);

        sheet.insertRule(`
          input[data-testid="field-email"] {
            display: flex !important;
            align-items: center !important;
            border-radius: 86px !important;
            border: 1px solid #565652 !important;
            background: #161613 !important;
            color: #B8B1AA !important;
            font-family: 'Roboto Condensed', sans-serif !important;
            font-size: 20px !important;
            font-style: normal !important;
            font-weight: 300 !important;
            line-height: normal !important;
          }
        `);

        sheet.insertRule(`
          #app-embed ._formFieldContainer_1ydxd_5 ._inputFilled_1ydxd_73 {
            display: none;
          }
      `);

      sheet.insertRule(`
          #app-embed ._formInputFieldLabel_ck6wz_38 {
          color: #B8B1AA;
          font-family: "Roboto Condensed";
          font-size: clamp(16px,1vw,20px);
          font-style: normal;
          font-weight: 300;
          line-height: normal;

          }
      `);

      sheet.insertRule(`
        #app-embed ._formFieldContainer_ck6wz_5:focus-within ._formInputFieldLabel_ck6wz_38 {
          transition: transform 0.2s, color 0.2s;
          display:none
        }
      `);

        sheet.insertRule(`
        :host {
          --form-field-border-focused: 0 0 0 1px #B8B1AA !important;
          --form-field-padding-top: 15px;
          --form-field-padding-bottom: 15px;
          --button-padding: 11px;

        }
      `);

      sheet.insertRule(`
          #app-embed ._formFieldContainer_ck6wz_5 input:not(:placeholder-shown) + ._formInputFieldLabel_ck6wz_38 {
          transform: none !important;
          color:transparent !important;
          transition: transform 0.2s, color 0.2s;
        }
      `);
        sheet.insertRule(`
          #app-embed form input._formInputField_237zm_7:focus-visible {
            box-shadow: none;
          }
      `);

        sheet.insertRule(`
          #app-embed form input._formInputField_237zm_7 {
            padding: 16px 20px;
          }
      `);

        sheet.insertRule(`
          #app-embed ._formFieldContainer_1ydxd_5:focus-within label {
              display: none;
          }
    `);

        sheet.insertRule(`
            #app-embed button._formSubmitButton_1nihh_77 {
                border-radius: 63.775px;
                border: 1px solid #565652;
                height: 12px;
                width: 12px;
                padding: 16px;
            }
        `);

        sheet.insertRule(`
          #app-embed button._formSubmitButton_1nihh_77:hover {
              background-color: #B8B1AA;
              transform: scale(1.1);
              box-shadow: 0 0 10px rgba(184, 177, 170, 0.5);
              border-color: rgba(255, 255, 255, 0.5);
          }
        `);

        sheet.insertRule(`
         #app-embed form._formFieldset_cit2d_82 {
          padding: 0 2px 2px 2px;
          display:flex;
          flex-direction:row;
          align-items:center;
          width:100%;
          max-width:440px;
          
          }
        `);

        sheet.insertRule(`
          #app-embed ._formSubmitButton_cit2d_96 {
          border-radius: 50%;
          width:28px;
          height:28px;
          border:0.7px solid #B8B1AA;
          color: #B8B1AA;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          text-align: center !important;
          }
        `);

        sheet.insertRule(`
        #app-embed ._formFieldContainer_ck6wz_5 {
          width:325px;
          flex:1;
        }
      `);

        sheet.insertRule(`
          #app-embed ._formError_ck6wz_21 {
            display:none !important
          }
        `);

        sheet.insertRule(`
          #app-embed div._withError_ck6wz_17 > input {
            box-shadow: 0 0 0 1px var(--form-error-color) !important;
          }
        `);

       

        sheet.insertRule(`
          @media (max-width: 430px) {
              #app-embed ._formFieldset_1nihh_63 {
                  flex-direction: column !important;
              }

            #app-embed ._formFieldContainer_1ydxd_5 label._formInputFieldLabel_1ydxd_37 {
              font-size: 16px !important;
            }

            #app-embed button._formSubmitButton_1nihh_77 {
                height: auto !important;
                min-width: -webkit-fill-available !important;
            }

            #app-embed button._formSubmitButton_1nihh_77:hover {
              transform: none !important;
          }
        `);

        shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];

        const mediaStyle = document.createElement("style");
        mediaStyle.textContent = `
        @media (min-width: 920px) and (max-width: 1024px) {
          
          #app-embed ._textBody_2aowh_10 {
            font-size: 16px !important;
          }

          #app-embed form._formFieldset_cit2d_82 {
          width: 100% !important;
          max-width: 350px !important;
          
          }
        }

        @media(min-width: 881px) and (max-width: 919px){
            #app-embed ._textBody_2aowh_10 {
            font-size: 16px !important;
          }

          #app-embed form._formFieldset_cit2d_82 {
          width: 100% !important;
          max-width: 330px !important;
          
          }

        }

        @media(min-width: 520px) and (max-width: 880px){
           #app-embed ._textBody_2aowh_10 {
            font-size: 16px !important;
          }

          #app-embed form._formFieldset_cit2d_82 {
          width: 100% !important;
          max-width: 440px !important;
          
          }

        }

        @media(min-width: 460px) and (max-width: 519px){

          #app-embed ._textBody_2aowh_10 {
            font-size: 16px !important;
          }

          #app-embed form._formFieldset_cit2d_82 {
          width: 100% !important;
          max-width: 380px !important;
          
          }
        }
        @media(min-width: 395px) and (max-width: 459px){
           #app-embed ._textBody_2aowh_10 {
            font-size: 16px !important;
          }

          #app-embed form._formFieldset_cit2d_82 {
          width: 100% !important;
          max-width: 330px !important;
          
          }
        }

        @media(min-width: 360px) and (max-width: 394px) {
           #app-embed ._textBody_2aowh_10 {
            font-size: 16px !important;
          }

          #app-embed form._formFieldset_cit2d_82 {
          width: 100% !important;
          max-width: 300px !important;
          
          }

          #app-embed ._formInputFieldLabel_ck6wz_38 {
            font-size:15px !important;
        }
        }
        
      `;
        shadow.appendChild(mediaStyle);
      }
    });

    this.observer.observe(document.body, { childList: true, subtree: true });
  }
}

if (!customElements.get("custom-form-styles")) {
  customElements.define("custom-form-styles", CustomFormStyles);
}
